import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { IProduct } from '../../../types/product'
import { getUrlWithVersion } from '../../../api/api'

export const fetchProducts = createAsyncThunk<
    { products: IProduct[] },
    { isInitialFetch: boolean },
    ThunkConfig<string>
>('productsSlice/fetchProducts', async (_, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    try {
        const { data } = await api.get<IProduct[]>(
            getUrlWithVersion(`/products`)
        )
        return { products: data }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to fetch product groups')
    }
})
